<template>
    <AppLayout
        ref="layout"
        page="/dashboard"
        pageTitle="Event History"
        backLink="/dashboard/reports"
    >
        <v-col cols="12" class="pa-1">
            <Stats class="pb-3" :stats="stats" />
            <v-card class="soli-round">
                <v-container class="px-3" fluid>
                    <ReportHeader
                        :subtitle="
                            allLocations
                                ? 'Events By Location'
                                : `${selectedLocation.name} Events`
                        "
                        :allLocations="allLocations"
                        locationOptions
                        :selectedLocation="selectedLocation"
                        filter
                        :dateRange="dateRange"
                        reportUrl="/dashboard/reports/event-history"
                        dateOptions="past, upcoming, month, year"
                        @search="search = $event"
                    />
                    <v-data-table
                        ref="table"
                        :headers="headers"
                        :items="eventRegisters"
                        hide-default-footer
                        disable-pagination
                        mobile-breakpoint="0"
                        :search="search"
                        :groupBy="allLocations ? 'location' : null"
                        @current-items="collapse()"
                        @click:row="
                            $inertia.get(
                                route('eventRegistration.show', $event.hashId)
                            )
                        "
                        class="cursor-pointer table-nowrap"
                    >
                        <template
                            v-slot:[`group.header`]="{
                                group,
                                items,
                                isOpen,
                                toggle,
                            }"
                        >
                            <th :colspan="headers.length">
                                <v-row
                                    no-gutters
                                    class="flex justify-start align-center pa-2"
                                >
                                    <v-icon @click="toggle" class="mr-3"
                                        >{{ isOpen ? "remove" : "add" }}
                                    </v-icon>
                                    <v-col>
                                        <div
                                            class="soli-grey text-subtitle-2 font-weight-bold"
                                        >
                                            {{ group }}
                                        </div>
                                        <div class="soli-grey text-small">
                                            • {{ items.length }} Event(s)
                                        </div>
                                    </v-col>
                                </v-row>
                            </th>
                        </template>
                        <template v-slot:[`item.start_date`]="{ item }">
                            <div class="d-flex items-center">
                                {{ item.date }}
                            </div>
                        </template>
                    </v-data-table>
                </v-container>
            </v-card>
        </v-col>
    </AppLayout>
</template>

<script>
import AppLayout from "./../../Layouts/AppLayout";
import { Link } from "@inertiajs/vue2";
import ReportHeader from "../../Components/Reports/ReportHeader.vue";
import Stats from "../../Components/Reports/Stats.vue";
import Clipboard from "../../Components/Clipboard.vue";

export default {
    props: {
        errors: {
            type: Object,
            default: () => ({}),
        },
        eventRegisters: {
            type: Array,
            default: () => [],
        },
        meta: {
            type: Array,
            default: () => [],
        },
        selectedLocation: {
            type: Object,
            default: () => {},
        },
        allLocations: {
            type: Boolean,
            default: false,
        },
        dateRange: {
            type: Array,
            default: () => [],
        },
    },
    components: {
        AppLayout,
        Link,
        ReportHeader,
        Stats,
        Clipboard,
    },
    data() {
        return {
            search: "",
            selection: null,
            showMessage: false,
            expanded: [],
            headers: [
                {
                    text: "Event",
                    align: "start",
                    sortable: true,
                    value: "name",
                },
                {
                    text: "Dates",
                    align: "start",
                    sortable: true,
                    value: "start_date",
                },
                {
                    text: "Time",
                    align: "start",
                    sortable: true,
                    value: "time",
                },
                {
                    text: "Attendees",
                    align: "start",
                    sortable: true,
                    value: "attending",
                },
            ],
        };
    },
    computed: {
        stats() {
            return [
                {
                    title: "Events",
                    data: this.eventRegisters.length,
                    color: "accent",
                    icon: "event",
                },
            ];
        },
    },
    methods: {
        collapse() {
            if (!this.allLocations) return;
            this.$nextTick(() => {
                let obj = this.$refs.table.openCache;
                Object.keys(obj).forEach((e) => (obj[e] = false));
            });
        },
    },
};
</script>
